import LoggerService from "@/services/LoggerService";

export function handleApiError(error, defaultMessage = "An error occurred", logError = true) {
    let errorMessage = defaultMessage;
    
    if (error.response) {
        const apiMessage =
            error.response.data?.message ||
            error.response.data?.error ||
            error.response.data?.detail;

        if (apiMessage) {
            errorMessage = apiMessage;
        } else {
            switch (error.response.status) {
                case 400:
                    errorMessage = "Bad request";
                    break;
                case 401:
                    errorMessage = "Unauthorized: Please log in again.";
                    break;
                case 403:
                    errorMessage = "Forbidden: You do not have permission.";
                    break;
                case 404:
                    errorMessage = "Not found: The requested resource does not exist.";
                    break;
                case 409:
                    errorMessage = "Conflict: Another process or dependency issue.";
                    break;
                case 500:
                    errorMessage = "Server error: Please try again later.";
                    break;
                default:
                    errorMessage = defaultMessage;
            }
        }
    } else if (error.request) {
        errorMessage = "Network error: Unable to reach server.";
    } else {
        errorMessage = error.message || defaultMessage;
    }
    
    // Log API errors
    if (logError) {
        const endpoint = error.config?.url || 'unknown';
        const method = error.config?.method?.toUpperCase() || 'UNKNOWN';
        const requestData = error.config?.data;
        
        LoggerService.logAPIError(endpoint, method, error, requestData);
    }
    
    return errorMessage;
}